// extracted by mini-css-extract-plugin
module.exports = {"shineWrapper":"style_shineWrapper__aKKCo","shineContent":"style_shineContent__GgbSf","shineEffect":"style_shineEffect__jWRdd","shine":"style_shine__MjnQD"};